__turbopack_context__.v({
  "appear-slide-left": "CateogryFeatures-module-scss-module__6sH9-q__appear-slide-left",
  "bounceTwice": "CateogryFeatures-module-scss-module__6sH9-q__bounceTwice",
  "fade-in-bottom": "CateogryFeatures-module-scss-module__6sH9-q__fade-in-bottom",
  "fade-in-left": "CateogryFeatures-module-scss-module__6sH9-q__fade-in-left",
  "fade-in-right": "CateogryFeatures-module-scss-module__6sH9-q__fade-in-right",
  "fadeIn": "CateogryFeatures-module-scss-module__6sH9-q__fadeIn",
  "features": "CateogryFeatures-module-scss-module__6sH9-q__features",
  "flexContainer": "CateogryFeatures-module-scss-module__6sH9-q__flexContainer",
  "loader": "CateogryFeatures-module-scss-module__6sH9-q__loader",
  "puff-in-center": "CateogryFeatures-module-scss-module__6sH9-q__puff-in-center",
  "puff-in-left": "CateogryFeatures-module-scss-module__6sH9-q__puff-in-left",
  "pulse": "CateogryFeatures-module-scss-module__6sH9-q__pulse",
  "pulse-contact": "CateogryFeatures-module-scss-module__6sH9-q__pulse-contact",
  "shake-bottom": "CateogryFeatures-module-scss-module__6sH9-q__shake-bottom",
  "slide-again": "CateogryFeatures-module-scss-module__6sH9-q__slide-again",
  "slide-in-right": "CateogryFeatures-module-scss-module__6sH9-q__slide-in-right",
  "stepContent-entrance": "CateogryFeatures-module-scss-module__6sH9-q__stepContent-entrance",
});
